import { render, staticRenderFns } from "./SegmentationGroup.vue?vue&type=template&id=15de61f3&scoped=true"
import script from "./SegmentationGroup.vue?vue&type=script&lang=js"
export * from "./SegmentationGroup.vue?vue&type=script&lang=js"
import style0 from "./SegmentationGroup.vue?vue&type=style&index=0&id=15de61f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15de61f3",
  null
  
)

export default component.exports